export default "__VITE_ASSET__DIK0QMFT__"